import { styled as UIStyled } from '@ui-kitten/components';
// Write our own type def that doesn't require separate, generated type defs as the UI Kitten lib does
export default function (name) {
    return UIStyled(name);
}
//# sourceMappingURL=styled.js.map